(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fn-grip-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fn-grip-purchase')) {
    customElements.define('fn-grip-purchase', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const form = this.closest('form');
        if (!form) return;
        const signal = this.controller.signal;
        form.classList.add('fn-preset-ready');
        const sync = () => queueMicrotask(() => this.sync());
        form.addEventListener('click', event => {
          const custom = event.target.closest('[data-custom-quantity]');
          if (custom && this.contains(custom)) {
            const expanded = form.classList.toggle('fn-custom-open');
            custom.setAttribute('aria-expanded', String(expanded));
            if (expanded) form.querySelector('input[name="quantity"]')?.focus();
          }
          const button = event.target.closest('[data-grip-quantity]');
          if (button && this.contains(button) && !button.disabled) {
            const selector = form.querySelector('quantity-selector-component');
            if (selector?.setValue) {
              form.classList.remove('fn-custom-open');
              this.querySelector('[data-custom-quantity]').setAttribute('aria-expanded', 'false');
              selector.setValue(button.dataset.gripQuantity);
              selector.onQuantityChange();
              selector.updateButtonStates();
            }
          }
          sync();
        }, {signal});
        form.addEventListener('input', sync, {signal});
        form.addEventListener('change', sync, {signal});
        form.addEventListener('focusout', sync, {signal});
        this.observer = new MutationObserver(sync);
        this.observer.observe(form, {subtree:true, attributes:true, attributeFilter:['data-cart-quantity','min','max','step','disabled']});
        requestAnimationFrame(() => this.sync());
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
      sync() {
        const input = this.closest('form')?.querySelector('input[name="quantity"]');
        if (!input) return;
        const quantity = Number(input.value);
        const minimum = Number(input.min) || 1;
        const step = Number(input.step) || 1;
        const inCart = Number(input.dataset.cartQuantity) || 0;
        const maximum = Math.min(input.max ? Number(input.max) : Infinity, this.hasAttribute('data-stock') ? Number(this.dataset.stock) : Infinity) - inCart;
        this.querySelectorAll('[data-grip-quantity]').forEach(button => {
          const value = Number(button.dataset.gripQuantity);
          const disabled = input.disabled || value < minimum || value > maximum || (value - minimum) % step !== 0;
          if (button.disabled !== disabled) button.disabled = disabled;
          button.setAttribute('aria-pressed', String(quantity === value));
        });
        const output = this.querySelector('[data-grip-total]');
        if (Number.isFinite(quantity) && quantity >= minimum && Number.isInteger(quantity)) {
          output.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(quantity * Number(this.dataset.price) / 100);
        } else {
          output.textContent = '—';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fn-grip-size"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fn-grip-size')) {
    customElements.define('fn-grip-size', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-size]');
          if (!button || !this.contains(button)) return;
          this.select(button.dataset.size);
        }, {signal});
        document.addEventListener('submit', event => {
          if (this.dataset.selected !== 'mid') return;
          const productForm = event.target.closest('product-form-component');
          if (productForm?.dataset.productId === this.dataset.productId) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, {capture:true, signal});
        if (location.hash.startsWith('#FnMidWaitlist-') && this.querySelector('[data-waitlist-success], [data-waitlist-errors]')) this.select('mid');
      }
      select(size) {
        this.dataset.selected = size;
        this.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.size === size)));
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
